import { render } from "./BioOne.vue?vue&type=template&id=360e9476"
import script from "./BioOne.vue?vue&type=script&lang=js"
export * from "./BioOne.vue?vue&type=script&lang=js"

import "./BioOne.vue?vue&type=style&index=0&id=360e9476&lang=css"
script.render = render

export default script